export const GET_SIMULATION_DATA = 'GET_SIMULATION_DATA';